import React, { useEffect, useState } from "react";
import { useLogin, useRedirect } from "react-admin";
import { ThemeProvider } from "@material-ui/styles";
import { fetchUtils } from "react-admin";
import "./auth.scss";
import { Button, TextField, Box, Snackbar } from "@material-ui/core";
import { getYear } from "date-fns";
import { GetParam } from "utils/tools";
import Alert from "@material-ui/lab/Alert";
import Logo from "../../assets/images/logo.png";

const LoginPage = ({ theme }: any) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isErrorForgotPassword, setIsErrorForgotPassword] = useState(false);
  const [emailForgot, setEmailForgot] = useState("");
  const [isSuccessSentEmail, setIsSuccessSentEmail] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isErrorLogin, setIsErrorLogin] = useState(false);
  const [isUnauthorizedUser, setIsUnauthorizedUser] = useState(false);
  const apiUrl = process.env.REACT_APP_API_HOST;
  const httpClient = fetchUtils.fetchJson;
  const login = useLogin();
  const redirect = useRedirect();
  const param = GetParam();

  // action button for login
  const submitLogin = async (e: any) => {
    e.preventDefault();
    const credentials = {
      email,
      password,
    };
    setIsLoading(true);

    // try {
    //   const user = await Auth.signIn(email, password);
    //   setIsLoading(false);
    //   console.log("USER", user);
    // } catch (error) {
    //   setIsLoading(false);
    // }

    login(credentials)
      .then(() => {
        redirect("/dashboard");
      })
      .catch(() => {
        setIsLoading(false);
        setIsErrorLogin(true);
      });
  };
  // action link for forgot password
  const _onSubmitForgot = () => {
    setIsLoading(true);
    const body = {
      data: {
        email: emailForgot,
        type: "superadmin",
      },
    };
    // custom api and not use dataProvider,
    // cause dataProvider (create) return data.id
    httpClient(`${apiUrl}/api/ForgotPassword`, {
      method: "POST",
      body: JSON.stringify(body.data),
    })
      .then(() => {
        setIsSuccessSentEmail(true);
        setIsLoading(false);
        setIsErrorForgotPassword(false);
      })
      .catch((error: any) => {
        setIsSuccessSentEmail(false);
        setIsErrorForgotPassword(true);
        setIsLoading(false);
      });
  };

  const onClickForgot = () => {
    setIsForgotPassword(true);
  };

  const BackToLogin = () => (
    <Box style={{ margin: "20px 0" }}>
      <Button
        variant="text"
        onClick={() => {
          setIsForgotPassword(false);
          setIsSuccessSentEmail(false);
          setIsErrorForgotPassword(false);
        }}
      >
        Back to Login
      </Button>
    </Box>
  );

  const handleKeyDown = async (event: any) => {
    if (event.key === "Enter") {
      await submitLogin(event);
    }
  };

  useEffect(() => {
    if (param.get("err") === "1") {
      setIsUnauthorizedUser(true);
    }
  }, [param.get("err")]);

  return (
    <ThemeProvider theme={theme}>
      <div className="Auth">
        {/* {!isForgotPassword && ( */}
        <div className="LoginForm">
          <div className="left">
            <img src={Logo} alt="" />
          </div>
          <div className="right">
            <div className="container">
              {/* show login form */}
              {!isForgotPassword && (
                <form
                  name="loginform"
                  onSubmit={submitLogin}
                  onKeyDown={handleKeyDown}
                >
                  <h2>Login to SchoolBus Management System</h2>
                  <TextField
                    data-testid="email"
                    onChange={(e) => setEmail(e.target.value)}
                    fullWidth
                    label="Email"
                  />
                  <br />
                  <br />
                  <TextField
                    data-testid="password"
                    onChange={(e) => setPassword(e.target.value)}
                    fullWidth
                    label="Password"
                    type="password"
                  />
                  <Box style={{ marginTop: "20px" }}>
                    <Button
                      onClick={submitLogin}
                      color="secondary"
                      variant="contained"
                      disabled={isLoading}
                    >
                      Login
                    </Button>
                  </Box>
                  {isErrorLogin && (
                    <div className="error-message">
                      Error: Invalid email or password
                    </div>
                  )}
                  <Box style={{ margin: "20px 0" }}>
                    <Button variant="text" onClick={onClickForgot}>
                      Forgot Password
                    </Button>
                  </Box>
                </form>
              )}
              {/* end of login form */}

              {/* show forgot password form */}
              {isForgotPassword && !isSuccessSentEmail && (
                <div className="ForgotPassword">
                  <div className="header">
                    <h2>Forgot your password?</h2>
                    <p>Enter your email address below to reset password.</p>
                  </div>
                  <TextField
                    onChange={(e) => setEmailForgot(e.target.value)}
                    fullWidth
                    label="Email"
                  />
                  {isErrorForgotPassword && (
                    <div className="error-message">Error: Invalid email</div>
                  )}
                  <br />
                  <br />
                  <Button
                    color="secondary"
                    variant="contained"
                    onClick={_onSubmitForgot}
                  >
                    Submit
                  </Button>
                  <BackToLogin />
                </div>
              )}
              {/* end forgot password form */}

              {/* Successfully forgotten a password */}
              {isForgotPassword && isSuccessSentEmail && (
                <div className="ForgotPasswordMessage">
                  <div className="message">
                    <h2>Please Check Your Email</h2>
                    <p>
                      If your email is valid, a reset password instruction has
                      been sent to you.
                    </p>
                  </div>
                  <BackToLogin />
                </div>
              )}
              {/* End of successfully forgotten a password */}

              {isLoading && (
                <div className="loading">
                  <div className="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              )}

              {isUnauthorizedUser && (
                <Snackbar
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  open={isUnauthorizedUser}
                  autoHideDuration={6000}
                  onClose={() => setIsUnauthorizedUser(false)}
                >
                  <Alert severity="error" elevation={6} variant="filled">
                    Unauthorized User!
                  </Alert>
                </Snackbar>
              )}
            </div>
          </div>
        </div>

        <div className="footer">
          Copyright {getYear(new Date())} SFX Transport Service Pte Ltd All
          rights reserved.
        </div>
      </div>
    </ThemeProvider>
  );
};

export default LoginPage;
